import { SalesRequest } from "~/types/client";

/**
 * Gets the display identifier for a sales request
 * Returns factura number if available, otherwise returns truncated order ID
 */
export const getDisplayId = (order: SalesRequest): string => {
  if (order.factura_number) {
    return "Factura: " + order.factura_number;
  }
  return `${order.id.slice(0, 8)}...`;
};

/**
 * Checks if a sales request has a factura
 */
export const hasFactura = (order: SalesRequest): boolean => {
  return !!order.factura_number;
};
